import { LayoutsComponent } from './components/layouts/layouts.component';
import { NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Router, NavigationStart, NavigationEnd, RouterModule } from '@angular/router';
import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { MenuLeftComponent } from './home-page/menu-left/menu-left.component';
import { LoginModule } from './login/login.module';
import { AuthGuard } from './login/AuthGuard/auth.guard';
import { RoleGuard } from './login/AuthGuard/role.guard';
import { DashboardModule } from './home-page/dashboards.module';







// declare var NProgress: any;

@NgModule({
    declarations: [
        AppComponent,
        LayoutsComponent,
        MenuLeftComponent,
    ],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpModule,
        RouterModule,
        LoginModule,
        DashboardModule,
        routing,
        

    ],
    providers: [AuthGuard, RoleGuard],
    bootstrap: [ AppComponent ]
})

export class AppModule {
  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if(event instanceof NavigationStart) {
        // NProgress.start();
      }

      if(event instanceof NavigationEnd) {
        // setTimeout(function(){
          // NProgress.done();
        // }, 200);
      }

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts